var _defs, _rect, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellerProfileMinimal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .surface { fill: #ffffff; }\n      .bg-light { fill: #f5f7fb; }\n      .text-dark { fill: #101828; }\n      .text-gray { fill: #6b7280; }\n      .text-light { fill: #344054; }\n      .green-primary { fill: #198754; }\n      .border-gray { stroke: #eaecf0; stroke-width: 1; }\n      .shadow { filter: drop-shadow(0 1px 2px rgba(0,0,0,0.05)); }\n      .shadow-md { filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1)); }\n      .font-bold { font-weight: 700; }\n      .font-semibold { font-weight: 600; }\n      .text-lg { font-size: 16px; }\n      .text-base { font-size: 14px; }\n      .text-sm { font-size: 13px; }\n      .text-xs { font-size: 12px; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    className: "bg-light"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 340,
    rx: 12,
    className: "surface shadow-md border-gray"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65, 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    className: "bg-light",
    stroke: "#198754",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 55,
    textAnchor: "middle",
    className: "text-2xl"
  }, "\uD83C\uDFE2"), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 10,
    className: "green-primary"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 81,
    textAnchor: "middle",
    fill: "white",
    className: "font-bold text-xs"
  }, "\u2713")), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 108,
    textAnchor: "middle",
    className: "text-base font-semibold text-dark"
  }, "Chukwu Properties"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 130,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "\u2605\u2605\u2605\u2605\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 145,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "(156)"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 165,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "\uD83D\uDCCD Lagos"), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 180,
    x2: 245,
    y2: 180,
    className: "border-gray"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 190)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 0,
    textAnchor: "middle",
    className: "text-base font-bold green-primary"
  }, "247"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 18,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "Listed"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 0,
    textAnchor: "middle",
    className: "text-base font-bold green-primary"
  }, "12"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 18,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "This Month")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "green-primary"
  }), /*#__PURE__*/React.createElement("text", {
    x: 37.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base",
    fill: "white"
  }, "\u260E\uFE0F"), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "surface border-gray"
  }), /*#__PURE__*/React.createElement("text", {
    x: 122.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base text-light"
  }, "\uD83D\uDCAC"), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "surface border-gray"
  }), /*#__PURE__*/React.createElement("text", {
    x: 207.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base"
  }, "\u2661")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(340, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 340,
    rx: 12,
    className: "surface shadow-md border-gray"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65, 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    className: "bg-light",
    stroke: "#198754",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 55,
    textAnchor: "middle",
    className: "text-2xl"
  }, "\uD83C\uDFE2"), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 10,
    className: "green-primary"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 81,
    textAnchor: "middle",
    fill: "white",
    className: "font-bold text-xs"
  }, "\u2713")), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 108,
    textAnchor: "middle",
    className: "text-base font-semibold text-dark"
  }, "Landmark Estates"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 130,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "\u2605\u2605\u2605\u2605\u2606"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 145,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "(124)"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 165,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "\uD83D\uDCCD Abuja"), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 180,
    x2: 245,
    y2: 180,
    className: "border-gray"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 190)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 0,
    textAnchor: "middle",
    className: "text-base font-bold green-primary"
  }, "189"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 18,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "Listed"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 0,
    textAnchor: "middle",
    className: "text-base font-bold green-primary"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 18,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "This Month")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "green-primary"
  }), /*#__PURE__*/React.createElement("text", {
    x: 37.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base",
    fill: "white"
  }, "\u260E\uFE0F"), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "surface border-gray"
  }), /*#__PURE__*/React.createElement("text", {
    x: 122.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base text-light"
  }, "\uD83D\uDCAC"), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "surface border-gray"
  }), /*#__PURE__*/React.createElement("text", {
    x: 207.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base"
  }, "\u2661")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(640, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 340,
    rx: 12,
    className: "surface shadow-md border-gray"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65, 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    className: "bg-light",
    stroke: "#198754",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 55,
    textAnchor: "middle",
    className: "text-2xl"
  }, "\uD83C\uDFE2"), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 10,
    className: "green-primary"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 81,
    textAnchor: "middle",
    fill: "white",
    className: "font-bold text-xs"
  }, "\u2713")), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 108,
    textAnchor: "middle",
    className: "text-base font-semibold text-dark"
  }, "Elite Properties"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 130,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "\u2605\u2605\u2605\u2605\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 145,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "(187)"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 165,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "\uD83D\uDCCD Ikoyi"), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 180,
    x2: 245,
    y2: 180,
    className: "border-gray"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 190)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 0,
    textAnchor: "middle",
    className: "text-base font-bold green-primary"
  }, "342"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 18,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "Listed"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 0,
    textAnchor: "middle",
    className: "text-base font-bold green-primary"
  }, "19"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 18,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "This Month")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "green-primary"
  }), /*#__PURE__*/React.createElement("text", {
    x: 37.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base",
    fill: "white"
  }, "\u260E\uFE0F"), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "surface border-gray"
  }), /*#__PURE__*/React.createElement("text", {
    x: 122.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base text-light"
  }, "\uD83D\uDCAC"), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "surface border-gray"
  }), /*#__PURE__*/React.createElement("text", {
    x: 207.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base"
  }, "\u2661")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(940, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 340,
    rx: 12,
    className: "surface shadow-md border-gray"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65, 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    className: "bg-light",
    stroke: "#198754",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 55,
    textAnchor: "middle",
    className: "text-2xl"
  }, "\uD83C\uDFE2"), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 10,
    className: "green-primary"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 81,
    textAnchor: "middle",
    fill: "white",
    className: "font-bold text-xs"
  }, "\u2713")), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 108,
    textAnchor: "middle",
    className: "text-base font-semibold text-dark"
  }, "Premium Realty"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 130,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "\u2605\u2605\u2605\u2605\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 145,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "(203)"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 165,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "\uD83D\uDCCD Lagos"), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 180,
    x2: 245,
    y2: 180,
    className: "border-gray"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 190)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 0,
    textAnchor: "middle",
    className: "text-base font-bold green-primary"
  }, "421"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 18,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "Listed"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 0,
    textAnchor: "middle",
    className: "text-base font-bold green-primary"
  }, "31"), /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 18,
    textAnchor: "middle",
    className: "text-xs text-gray"
  }, "This Month")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "green-primary"
  }), /*#__PURE__*/React.createElement("text", {
    x: 37.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base",
    fill: "white"
  }, "\u260E\uFE0F"), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "surface border-gray"
  }), /*#__PURE__*/React.createElement("text", {
    x: 122.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base text-light"
  }, "\uD83D\uDCAC"), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 0,
    width: 75,
    height: 36,
    rx: 6,
    className: "surface border-gray"
  }), /*#__PURE__*/React.createElement("text", {
    x: 207.5,
    y: 23,
    textAnchor: "middle",
    className: "text-base"
  }, "\u2661")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 420)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    className: "text-base font-bold text-dark"
  }, "\uD83C\uDFA8 Brand Colors"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 40,
    height: 40,
    rx: 4,
    className: "green-dark"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 45,
    className: "text-sm text-dark"
  }, "Dark Green #0f5132"), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 20,
    width: 40,
    height: 40,
    rx: 4,
    className: "green-primary"
  }), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 45,
    className: "text-sm text-dark"
  }, "Primary Green #198754"), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 20,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#6edba4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 45,
    className: "text-sm text-dark"
  }, "Light Green #6edba4"), /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 20,
    width: 40,
    height: 40,
    rx: 4,
    className: "border-gray"
  }), /*#__PURE__*/React.createElement("text", {
    x: 950,
    y: 45,
    className: "text-sm text-dark"
  }, "Light BG #f5f7fb"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellerProfileMinimal);
export default __webpack_public_path__ + "static/media/seller-profile-minimal.3c4737e5ca6cd7fe011691573508a4db.svg";
export { ForwardRef as ReactComponent };